import { CompanyInvitationByTokenContent } from "../../features/companyWorkspace";

function CompanyInvitationByTokenScreen() {
  return <CompanyInvitationByTokenContent />;
}

export default CompanyInvitationByTokenScreen;
